import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: [
    'user.',
    'site.',
    'accounting_reference.',
    'vehicle.',
    'company.',
    'org_unit.',
    'user_group.',
  ],
};
